"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteSample = exports.SchoolRouteSample = void 0;
var SchoolRouteSample = /** @class */ (function () {
    function SchoolRouteSample() {
    }
    return SchoolRouteSample;
}());
exports.SchoolRouteSample = SchoolRouteSample;
// tslint:disable-next-line:max-classes-per-file
var RouteSample = /** @class */ (function (_super) {
    __extends(RouteSample, _super);
    function RouteSample() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RouteSample;
}(SchoolRouteSample));
exports.RouteSample = RouteSample;
//# sourceMappingURL=RouteSample.js.map